<template>
  <div class="f40-wrap">
    <section ref="print">
      <div class="mytitle">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>{{
              this.$moment(this.startDate).format("YYYY-MM-DD")
            }}</span>
            <span v-if="$parent.endTimeShow"
              >至{{
                this.$moment(this.endDate).format("YYYY-MM-DD")
              }}</span
            >
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>{{ userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
          </li> -->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="table">
        <div class="f40-item">
          <div>房间号</div>
          <div>账号</div>
          <div>姓名</div>
          <div>到店日期</div>
          <div>离店日期</div>
          <div style="text-align:right">房价</div>

          <div>客房类型</div>
          <div>状态</div>
        </div>
        <div class="f40-item2" v-for="(item, index) in list" :key="index">
          <div class="f40-item3">
            <div>{{ item.roomName }}</div>
            <div>{{ item.accNo }}</div>
            <div>{{ item.guestName }}</div>
            <div>{{ item.arrival }}</div>
            <div>{{ item.departure }}</div>
            <div>{{ curreny(item.rate) }}</div>
            <div>{{ item.roomTypeName }}</div>
            <div v-if="item.status == 'R'">预订</div>
            <div v-if="item.status == 'I'">入住</div>
            <div v-if="item.status == 'O'">离店</div>
            <div v-if="item.status == 'C'">取消</div>
            <div v-if="item.status == 'N'">未到</div>
            <div v-if="item.status == 'S'">悬单</div>
          </div>
          <div
            class="f40-item3"
            v-for="(item2, index2) in item.children"
            :key="index2"
          >
            <div>{{ item2.roomName }}</div>
            <div>{{ item2.accNo }}</div>
            <div>{{ item2.guestName }}</div>
            <div>{{ item2.arrival }}</div>
            <div>{{ item2.departure }}</div>
            <div style="text-align:right">{{ curreny(item2.rate) }}</div>
            <div>{{ item2.roomTypeName }}</div>
            <div v-if="item2.status == 'R'">预订</div>
            <div v-if="item2.status == 'I'">入住</div>
            <div v-if="item2.status == 'O'">离店</div>
            <div v-if="item2.status == 'C'">取消</div>
            <div v-if="item2.status == 'N'">未到</div>
            <div v-if="item2.status == 'S'">悬单</div>
          </div>
          <div class="f40-item4" style="line-height: 30px">
            <div></div>
            <div>同行主账号：</div>
            <div>{{ item.postLinkAccNo }}</div>
            <div>同行房间数：</div>
            <div>{{ item.roomNum }}间</div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="f40-item" style="font-weight: bold">
          <div></div>
          <div>共计：</div>
          <div>{{ list.length }}组同行</div>
          <div></div>
          <div>共{{ total }}间</div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      // nowday: this.$moment(new Date()).format("YYYY-MM-DD"),
      // nowtime: this.$moment(new Date()).format("HH:mm:ss"),
      hotelName: localStorage.getItem("cname"),
      bbmc: "F40 当日同行/成员列表",
      roomId: null,
      list: [],
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    hotelInfo() {
      return this.$store.state.hotelInfo;
    },
    rooms() {
      return this.$store.state.tRoomInfo;
    },
    total() {
      let num = 0;
      this.list.forEach((item) => {
        num += parseInt(item.roomNum);
      });
      return num;
    },
  },
  created() {
    this.$parent.closeshow();
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.startTimeShow = true;
    this.$parent.endTimeShow = true;
    this.$parent.chaxunvib = true;
    this.getData();
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach() {
      if (new Date(this.$parent.startDate) <= new Date(this.$parent.endDate)) {
        this.getData();
      } else {
        this.$mymessage({
          content: "截止日期必须大于开始日期",
          type: "error",
          time: 3000,
          hasClose: true,
        });
      }
      
    },
    getData() {
      let that = this;
      this.roomId = null;
      if (this.$parent.roomno != null) {
        let roomNo = this.$parent.roomno;

        this.rooms.forEach((item) => {
          if (item.cno == roomNo) {
            this.roomId = item.iid;
          }
        });
      }

      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("/reportForFront/selectPeerMembers", {
        startDate: this.$parent.startDate,
        endDate: this.$parent.endDate,
        roomId: this.roomId,
      }).then((res) => {
        
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          that.$parent.datacount = res.data.length;
          that.list = res.data;
          res.data.forEach((item) => {
            item.children.forEach((childrenItem) => {
              res.data.push(childrenItem);
            });
          });
          
          this.$store.state.preArrivalList = res.data;
          this.$store.state.preArrivalName = "F40 当日同行/成员列表";
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
    curreny(data) {
      
      if (data == "NaN" || data == undefined || data == null) {
        return null;
      }
      data = Number(data).toFixed(2);
      return data;
    },
  },
};
</script>

<style scoped>
.f40-wrap {
  width: 100%;
  font-size: 14px;
}
.table {
  width: 100%;
}
.f40-item,
.f40-item3 {
  display: flex;
  line-height: 26px;
}
.table .f40-item:nth-child(1) {
  border-top: 1px solid #666;
  border-bottom: 1px solid #666;
  margin-top: 30px;
}
.f40-item > div,
.f40-item3 > div,
.f40-item4 > div {
  flex: 1;
  text-align: center;
}
.f40-item4 > div {
  font-weight: bold;
}
.f40-item2 {
  width: 100%;
}
.f40-item4 {
  display: flex;
  border-bottom: 1px solid #666;
}
.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}
</style>